import React, { useState } from "react";
import {
  Box,
  BoxProps,
  ButtonGroup,
  DarkMode,
  Flex,
  IconButton,
  chakra,
} from "@chakra-ui/react";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import { HOME_PAGE_PY } from "./HomePage";

type HomePageTestimonialsProps = {
  testimonials: string[];
} & BoxProps;

export function HomePageTestimonials({
  testimonials,
  ...props
}: HomePageTestimonialsProps) {
  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <DarkMode>
      <Box
        as="section"
        roundedTop={{
          base: 48,
          lg: 100,
        }}
        color="whiteAlpha.900"
        bg="black.200"
        overflow="hidden"
      >
        <Box
          py={{
            base: 8,
            md: 12,
            lg: HOME_PAGE_PY.lg,
          }}
          {...props}
        >
          <chakra.h2
            mb={{
              base: 4,
              lg: 12,
            }}
            textStyle="smallCaps"
            textAlign={{
              base: "center",
              md: "left",
            }}
          >
            What developers say about our GraphQL tutorials
          </chakra.h2>
          <Flex
            mb={{
              base: 8,
              lg: 12,
            }}
            transitionProperty="common"
            transitionDuration="slow"
            transform={`translateX(${-100 * activeIndex}%)`}
          >
            {testimonials.map((testimonial, index) => (
              <Box
                flexShrink={0}
                w="full"
                key={index}
                fontSize={{
                  base: "3xl",
                  md: "4xl",
                  lg: "5xl",
                }}
                lineHeight="normal"
                transitionProperty="common"
                transitionDuration="slow"
                opacity={Number(index === activeIndex)}
              >
                &ldquo;{testimonial}&rdquo;
              </Box>
            ))}
          </Flex>
          <ButtonGroup>
            <IconButton
              isRound
              aria-label="Previous testimonial"
              icon={<FiArrowLeft />}
              onClick={() =>
                setActiveIndex((prev) =>
                  prev ? prev - 1 : testimonials.length - 1
                )
              }
            />
            <IconButton
              isRound
              aria-label="Next testimonial"
              icon={<FiArrowRight />}
              onClick={() =>
                setActiveIndex((prev) =>
                  prev === testimonials.length - 1 ? 0 : prev + 1
                )
              }
            />
          </ButtonGroup>
        </Box>
      </Box>
    </DarkMode>
  );
}
